export enum AppErrorKind {
  NETWORK = 'network',
  AUTH = 'auth',
  FORBIDDEN = 'forbidden',
  VALIDATION = 'validation',
  SERVER = 'server',
  UNKNOWN = 'unknown'
}

export interface AppError {
  kind: AppErrorKind
  // GraphQL `extensions.code` values, empty for transport-level errors
  codes: string[]
  // Raw technical message — for logs, not for the user (see getUserMessage)
  message: string
  original: unknown
}
